import React from 'react';

import './Dashboard.css';
import MerchantMenuService from "../../shared/service/MerchantMenuService";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import {normalizeMenuListResponse, resolveMenuHref, resolveMenuIcon, sortMenusByDescription} from "./dashboardMenuUtils";
import DashboardMenuIcon from "./DashboardMenuIcon";

export default class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {menuList: []};
        this.merchantMenuService = new MerchantMenuService();
    }

    componentDidMount = () => {
        this.merchantMenuService.findMenus().then(data => {
            this.setState({menuList: normalizeMenuListResponse(data)});
        });
    }

    getParentMenus() {
        if (GeneralUtils.isNullOrEmpty(this.state.menuList)) {
            return [];
        }
        return sortMenusByDescription(
            this.state.menuList.filter(item => GeneralUtils.isNullOrEmpty(item.parentId))
        );
    }

    getChildMenus(parent) {
        return sortMenusByDescription(
            this.state.menuList.filter(item => item.parentId == parent.id)
        );
    }

    renderMenuTile(item) {
        const href = resolveMenuHref(item);
        const iconClass = resolveMenuIcon(item);
        return (
            <a key={item.id} href={href} className="dashboard-launcher__tile">
                <span className="dashboard-launcher__tile-icon" aria-hidden="true">
                    <DashboardMenuIcon iconClass={iconClass}/>
                </span>
                <span className="dashboard-launcher__tile-label">{item.description}</span>
            </a>
        );
    }

    render() {
        const parents = this.getParentMenus();
        if (parents.length === 0) {
            return null;
        }

        return (
            <div className="dashboard-launcher">
                {parents.map(parent => {
                    const children = this.getChildMenus(parent);
                    if (children.length === 0) {
                        return null;
                    }
                    return (
                        <section key={parent.id} className="dashboard-launcher__section">
                            <h2 className="dashboard-launcher__section-title">{parent.description}</h2>
                            <div className="dashboard-launcher__grid">
                                {children.map(child => this.renderMenuTile(child))}
                            </div>
                        </section>
                    );
                })}
            </div>
        );
    }
}
